import TextPlaceholder from 'components/ui/layout/TextPlaceholder/TextPlaceholder'

export default TextPlaceholder
